import React from "react";
import "./ResidentialRooftop.css";
import rrHeroImg from "../../assets/RRsection1.png";
import rrBenefitsImg from "../../assets/RRsection2.png";
import rrDiff1 from "../../assets/residentialdifference-1.png";
import rrDiff2 from "../../assets/residentialdifference-2.png";
import rrDiff3 from "../../assets/residentialdifference-3.png";
import rrDiff4 from "../../assets/residentialdifference-4.png";
import rrDiff5 from "../../assets/residentialdifferenece-5.png";
import rrDiff6 from "../../assets/residentialdifferenece-6.png";
import { useState } from "react";
import rrPanel1 from "../../assets/RRsection3-1.png";
import rrPanel2 from "../../assets/RRsection3-2.png";
import rrPanel3 from "../../assets/RRsection3-3.png";
import rrPanel4 from "../../assets/residentialadvanced-4.png";
import rrPanel5 from "../../assets/residentialadvanced-5.png";
import rrBatt1 from "../../assets/RRsection4-1.png";
import rrBatt2 from "../../assets/RRsection4-2.png";
import rrBatt3 from "../../assets/RRsection4-3.png";
import rrBatt4 from "../../assets/RRsection4-4.png";
import rrArch1 from "../../assets/RRsection5-1.png";
import rrArch2 from "../../assets/RRsection5-2.png";
import rrArch3 from "../../assets/RRsection5-3.png";
import rrArch4 from "../../assets/residentialsolutions-4.png";
import { useRef, useEffect } from "react";
import RRs1step1 from "../../assets/RR-s1-step1.png";
import RRs1step2 from "../../assets/RR-s1-step2.png";
import RRs1step3 from "../../assets/RR-s1-step3.png";
import RRs1step4 from "../../assets/RR-s1-step4.png";
import RRs1step5 from "../../assets/RR-s1-step5.png";
import RRs1step6 from "../../assets/RR-s1-step6.png";
import RRs2step1 from "../../assets/RR-s2-step1.png";
import RRs2step2 from "../../assets/RR-s2-step2.png";
import RRs2step3 from "../../assets/RR-s2-step3.png";
import RRs2step4 from "../../assets/RR-s2-step4.png";
import RRs2step5 from "../../assets/RR-s2-step5.png";
import RRs2step6 from "../../assets/RR-s2-step6.png";
import RRs3step1 from "../../assets/RR-s3-step1.png";
import RRs3step2 from "../../assets/RR-s3-step2.png";
import RRs3step3 from "../../assets/RR-s3-step3.png";
import RRs3step4 from "../../assets/RR-s3-step4.png";
import RRs3step5 from "../../assets/RR-s3-step5.png";
import RRs3step6 from "../../assets/RR-s3-step6.png";
import RRs3step7 from "../../assets/RR-s3-step7.png";
import RRs4step1 from "../../assets/RR-s4-step1.png";
import RRs4step2 from "../../assets/RR-s4-step2.png";
import RRs4step3 from "../../assets/RR-s4-step3.png";
import RRs4step4 from "../../assets/RR-s4-step4.png";
import RRs4step5 from "../../assets/RR-s4-step5.png";
import RRs4step6 from "../../assets/RR-s4-step6.png";
import RRs5step1 from "../../assets/RR-s5-step1.png";
import RRs5step2 from "../../assets/RR-s5-step2.png";
import RRs5step3 from "../../assets/RR-s5-step3.png";
import RRs5step4 from "../../assets/RR-s5-step4.png";
import RRs5step5 from "../../assets/RR-s5-step5.png";
import RRs5step6 from "../../assets/RR-s5-step6.png";
import RRs6step1 from "../../assets/RR-s6-step1.png";
import RRs6step2 from "../../assets/RR-s6-step2.png";
import RRs6step3 from "../../assets/RR-s6-step3.png";
import RRs6step4 from "../../assets/RR-s6-step4.png";
import RRs6step5 from "../../assets/RR-s6-step5.png";
import RRs6step6 from "../../assets/RR-s6-step6.png";
import RRs7step1 from "../../assets/RR-s7-step1.png";
import RRs7step2 from "../../assets/RR-s7-step2.png";
import RRs7step3 from "../../assets/RR-s7-step3.png";
import RRs7step4 from "../../assets/RR-s7-step4.png";
import RRs7step5 from "../../assets/RR-s7-step5.png";
import RRs7step6 from "../../assets/RR-s7-step6.png";
import RRs7step7 from "../../assets/RR-s7-step7.png";
import RRs7step8 from "../../assets/RR-s7-step8.png";
import RRs8step1 from "../../assets/RR-s8-step1.png";
import RRs8step2 from "../../assets/RR-s8-step2.png";
import RRs8step3 from "../../assets/RR-s8-step3.png";
import RRs8step4 from "../../assets/RR-s8-step4.png";
import RRs8step5 from "../../assets/RR-s8-step5.png";
import RRs8step6 from "../../assets/RR-s8-step6.png";
import RRs9step1 from "../../assets/RR-s9-step1.png";
import RRs9step2 from "../../assets/RR-s9-step2.png";
import RRs9step3 from "../../assets/RR-s9-step3.png";
import RRs9step4 from "../../assets/RR-s9-step4.png";
import RRs9step5 from "../../assets/RR-s9-step5.png";
import RRs9step6 from "../../assets/RR-s9-step6.png";
import RRs9step7 from "../../assets/RR-s9-step7.png";
import RRs10step1 from "../../assets/RR-s10-step1.png";
import RRs10step2 from "../../assets/RR-s10-step2.png";
import RRs10step3 from "../../assets/RR-s10-step3.png";
import RRs10step4 from "../../assets/RR-s10-step4.png";
import RRs10step5 from "../../assets/RR-s10-step5.png";
import RRs10step6 from "../../assets/RR-s10-step6.png";
import RRs10step7 from "../../assets/RR-s10-step7.png";
import RRs11step1 from "../../assets/RR-s11-step1.png";
import RRs11step2 from "../../assets/RR-s11-step2.png";
import RRs11step3 from "../../assets/RR-s11-step3.png";
import RRs11step4 from "../../assets/RR-s11-step4.png";
import RRs11step5 from "../../assets/RR-s11-step5.png";
import RRs11step6 from "../../assets/RR-s11-step6.png";
import RRs11step7 from "../../assets/RR-s11-step7.png";
import RRs12step1 from "../../assets/RR-s12-step1.png";
import RRs12step2 from "../../assets/RR-s12-step2.png";
import RRs12step3 from "../../assets/RR-s12-step3.png";
import RRs12step4 from "../../assets/RR-s12-step4.png";
import RRs12step5 from "../../assets/RR-s12-step5.png";
import rrWhyImg from "../../assets/RRsection7.png";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import rrProj1 from "../../assets/RRsection8-1.png";
import rrProj2 from "../../assets/RRsection8-2.png";
// import Testi1 from "../../assets/testi1.png";
// import Testi2 from "../../assets/testi2.png";
// import Testi3 from "../../assets/testi3.png";
/* ================================================
   SECTION 1 — HERO
   ================================================ */
const ResidentialRooftopHero = () => (
  <section className="rr-hero">
    {/* ── Top text row ── */}
    <div className="rr-hero-top">
      <h1 className="rr-hero-title">
        Smart, Silent, High-Performance Home Energy Systems
      </h1>
      <p className="rr-hero-desc">
        Designed for modern villas, independent homes, gated communities, and
        premium residential spaces, our systems combine performance, aesthetics,
        and long-term reliability.
      </p>
      <button className="rr-hero-cta">Book A Free Call</button>
    </div>

    {/* ── Bottom full-width image ── */}
    <div className="rr-hero-img-wrap">
      <img
        src={rrHeroImg}
        alt="Residential Rooftop Solar"
        className="rr-hero-img"
      />
    </div>
  </section>
);

/* ================================================
   SECTION 2 — THE PREMIUM DIFFERENCE
   ================================================ */
const rrBenefitItems = [
  {
    title: "Lower electricity bills for life",
    desc: "Produce your own clean power and reduce monthly costs.",
    img: rrDiff1,
  },
  {
    title: "More flexibility in system design",
    desc: "Choose your panel type, inverter brand, battery model, and backup capacity.",
    img: rrDiff2,
  },
  {
    title: "Fast Installation, Zero Hassle",
    desc: "No approvals or waiting processes. Quick, clean execution.",
    img: rrDiff3,
  },
  {
    title: "Full control over design & technology",
    desc: "Choose your preferred panel type, inverter brand, battery capacity, and layout.",
    img: rrDiff4,
  },
  {
    title: "Aesthetic, Silent & Generator-Free Backup",
    desc: "Black panels, hidden wiring, elevated mounts, and silent operation.",
    img: rrDiff5,
  },
  {
    title: "25+ Years of Reliable Performance",
    desc: "Built for long-term reliability and high-generation output.",
    img: rrDiff6,
  },
];

const ResidentialRooftopBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          rrBenefitItems.length - 1,
          Math.floor(p * rrBenefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="rr-benefits-outer"
      ref={outerRef}
      style={{ height: `${rrBenefitItems.length * 110}vh` }}
    >
      <section className="rr-benefits-sticky">
        <div className="rr-benefits">
          <div className="rr-benefits-header">
            <p className="rr-benefits-tag">
              <span className="rr-benefits-dot" />
              THE PREMIUM DIFFERENCE
            </p>
            <h2 className="rr-benefits-title">Smarter Energy For Modern Living</h2>
          </div>

          <div className="rr-benefits-body">
            <div className="rr-benefits-list">
              {rrBenefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`rr-benefit-item ${
                      i === activeIndex ? "rr-benefit-item--active" : ""
                    }`}
                    onClick={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && <span className="rr-benefit-bar" />}

                    <div className="rr-benefit-text">
                      <p className="rr-benefit-title">{item.title}</p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && (
                        <p className="rr-benefit-desc">{item.desc}</p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="rr-benefit-mobile-img-wrap">
                    <div className="rr-benefit-mobile-img-bg" />
                    <img
                      src={item.img}
                      alt={item.title}
                      className="rr-benefit-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < rrBenefitItems.length - 1 && (
                    <hr className="rr-benefit-divider" />
                  )}
                </div>
              ))}
            </div>

            <div className="rr-benefits-img-wrap">
              <div className="rr-benefits-img-bg" />
              <img
                src={rrBenefitItems[activeIndex].img}
                alt="Solar Panel"
                className="rr-benefits-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
/* ================================================
   SECTION 3 — ADVANCED SOLAR TECHNOLOGIES
   ================================================ */
const ResidentialRooftopPanels = () => {
  const panels = [
    {
      img: rrPanel1,
      title: "N-Type TOPCon Panels",
      bullets: [
        "Maximum efficiency",
        "Excellent performance in low light",
        "Lowest degradation rates",
        "Ideal for small rooftops needing high output",
      ],
    },
    {
      img: rrPanel2,
      title: "Bifacial Panels",
      bullets: [
        "Generation from front & rear sides",
        "3–12% higher yield depending on roof",
        "Perfect for elevated or high-reflective rooftops",
      ],
    },
    {
      img: rrPanel3,
      title: "All-Black Premium Panels",
      bullets: [
        "Elegant, seamless design",
        "No visible grid lines",
        "Perfect for villas and modern architecture",
      ],
    },
    {
      img: rrPanel4,
      title: "Microinverter Systems",
      bullets: [
        "Panel-level optimization",
        "Highest safety (no high-voltage DC)",
        "Best for homes requiring advanced monitoring",
        "Ideal for shade-prone rooftops",
      ],
    },
    {
      img: rrPanel5,
      title: "Hybrid Solar Inverters",
      bullets: [
        "Automatic switching between sources",
        "Backup integrated into the same inverter",
        "App-based smart monitoring",
        "Load priority control",
      ],
    },
  ];

  const [start, setStart] = useState(0);
  const total = panels.length;
  const visible = 3;

  const prev = () => setStart((s) => (s - 1 + total) % total);
  const next = () => setStart((s) => (s + 1) % total);

  const visiblePanels = Array.from(
    { length: visible },
    (_, i) => panels[(start + i) % total],
  );

  const ChevronLeft = () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );

  const ChevronRight = () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );

  return (
    <section className="rr-panels">
      {/* ── Header ── */}
      <div className="rr-panels-header">
        <p className="rr-panels-tag">
          <span className="rr-panels-dot" />
          ADVANCED SOLAR TECHNOLOGIES
        </p>
        <h2 className="rr-panels-title">
          Next-Generation Solar For Modern Homes
        </h2>
        <p className="rr-panels-subtitle">
          Next-generation panels and inverter systems engineered for higher
          yield, better low-light performance, and long-term reliability.
        </p>
      </div>

      {/* ── Cards ── */}
      <div className="rr-panels-grid">
        {visiblePanels.map((panel, i) => (
          <div className="rr-panels-card" key={i}>
            <div className="rr-panels-card-img-wrap">
              <img
                src={panel.img}
                alt={panel.title}
                className="rr-panels-card-img"
                loading="lazy"
              />
            </div>
            <div className="rr-panels-card-body">
              <h3 className="rr-panels-card-title">{panel.title}</h3>
              <ul className="rr-panels-card-list">
                {panel.bullets.map((b, j) => (
                  <li key={j} className="rr-panels-card-bullet">
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* ── Arrows ── */}
      <div className="rr-panels-arrows">
        <button
          className="rr-panels-arrow"
          onClick={prev}
          aria-label="Previous"
        >
          <ChevronLeft />
        </button>
        <button className="rr-panels-arrow" onClick={next} aria-label="Next">
          <ChevronRight />
        </button>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 4 — HOME BATTERY SYSTEMS
   ================================================ */
const ResidentialRooftopBattery = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const cards = [
    {
      img: rrBatt1,
      title: "LiFePO4 Lithium Batteries",
      bullets: [
        "High Safety",
        "Long lifespan (10-12 years)",
        "Zero maintenance",
        "Fast charging",
        "Compact & Silent",
      ],
    },
    {
      img: rrBatt2,
      title: "Modular Expandable Batteries",
      bullets: [
        "Scale from 5 kWh → 10 kWh → 15 kWh → 20 kWh",
        "Ideal for growing homes and villas",
        "Plug-and-play expansion",
      ],
    },
    {
      img: rrBatt3,
      title: "Whole-Home Backup Systems",
      bullets: [
        "Powers the entire house during outages",
        "Instant switching",
        "Silent alternative to diesel generators",
      ],
    },
    {
      img: rrBatt4,
      title: "Premium Smart Battery Ecosystems",
      bullets: [
        "Real-time app monitoring",
        "Load shifting automation",
        "Surge protection",
        "Temperature-controlled operation",
      ],
    },
  ];

  const prev = () => setActiveIndex((i) => (i - 1 + cards.length) % cards.length);
  const next = () => setActiveIndex((i) => (i + 1) % cards.length);

  const BattChevronLeft = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );

  const BattChevronRight = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );

  const CheckIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="rr-batt-check-icon"
    >
      <path
        d="M4 12.5L9.5 18L20 7"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <section className="rr-batt">
      {/* ── Header ── */}
      <div className="rr-batt-header">
        <p className="rr-batt-tag">
          <span className="rr-batt-dot" />
          HOME BATTERY SYSTEMS
        </p>
        <h2 className="rr-batt-title">Advanced Lithium Backup Solutions</h2>
        <p className="rr-batt-subtitle">
          High-safety LiFePO4 and modular lithium storage solutions designed for
          uninterrupted, scalable backup performance.
        </p>
      </div>

      {/* ── 2×2 Grid ── */}
      <div className="rr-batt-grid">
        {cards.map((card, i) => (
          <div className={`rr-batt-card${i === activeIndex ? " rr-batt-card--active" : ""}`} key={i}>
            {/* Product image floats above blue bg */}
            <div className="rr-batt-card-img-wrap">
              <img
                src={card.img}
                alt={card.title}
                className="rr-batt-card-img"
                loading="lazy"
              />
            </div>
            {/* Blue content area */}
            <div className="rr-batt-card-body">
              <h3 className="rr-batt-card-title">{card.title}</h3>
              <ul className="rr-batt-card-list">
                {card.bullets.map((b, j) => (
                  <li key={j} className="rr-batt-card-bullet">
                    <CheckIcon />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* ── Mobile carousel arrows ── */}
      <div className="rr-batt-arrows">
        <button className="rr-batt-arrow" onClick={prev} aria-label="Previous">
          <BattChevronLeft />
        </button>
        <button className="rr-batt-arrow" onClick={next} aria-label="Next">
          <BattChevronRight />
        </button>
      </div>

      {/* ── CTA footer ── */}
      <div className="rr-batt-footer">
        <p className="rr-batt-footer-text">
          Ready to power your home with intelligent, uninterrupted energy?
        </p>
        <button className="rr-batt-cta">Talk to Our Solar Experts</button>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 5 — SPECIALIZED & ARCHITECTURAL SOLAR SOLUTIONS
   ================================================ */
const ResidentialRooftopArchitecture = () => {
  const cards = [
    {
      img: rrArch1,
      title: "Solar Carport Structures",
      desc: "Shade + power + EV charging readiness.",
    },
    {
      img: rrArch2,
      title: "Elevated Rooftop Structures",
      desc: "Free up terrace usage for your family.",
    },
    {
      img: rrArch3,
      title: "Integrated Solar Tiles",
      desc: "Tile-like panels that blend into the roof.",
    },
    {
      img: rrArch4,
      title: "Hybrid Heat Pump + Solar Hot Water",
      desc: "Energy-efficient water heating systems.",
    },
  ];

  return (
    <section className="rr-arch">
      <div className="rr-arch-header">
        <p className="rr-arch-tag">
          <span className="rr-arch-dot" />
          RESIDENTIAL SOLUTIONS
        </p>
        <h2 className="rr-arch-title">
          Specialized & Architectural Solar Solutions
        </h2>
        <p className="rr-arch-desc">
          Design-forward solar structures that seamlessly integrate with your
          home—combining functionality, aesthetics, and long-term performance.
        </p>
      </div>

      <div className="rr-arch-scroll">
        {cards.map((card, i) => (
          <div className="rr-arch-card" key={i}>
            <div className="rr-arch-card-img-wrap">
              <img
                src={card.img}
                alt={card.title}
                className="rr-arch-card-img"
                loading="lazy"
              />
            </div>
            <div className="rr-arch-card-text">
              <h3 className="rr-arch-card-title">{card.title}</h3>
              <p className="rr-arch-card-desc">{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

/* ================================================
   SECTION 6 — HOW IT WORKS
   ================================================ */
const rrStages = [
  {
    id: 1,
    title: "Home Assessment",
    steps: [
      { title: "Detailed rooftop & site assessment (usable area + 3D mapping)" , image: RRs1step1},
      { title: "Household appliance energy profiling" , image: RRs1step2},
      { title: "Backup requirement assessment (lights / full home / EV / ACs)" , image: RRs1step3},
      { title: "DG + grid interaction feasibility" , image: RRs1step4},
      { title: "Architectural considerations (visibility, noise, placement)" , image: RRs1step5},
      { title: "Recommendations for on-grid, hybrid, or premium battery systems" , image: RRs1step6},
    ],
  },
  {
    id: 2,
    title: "Design & Aesthetics",
    steps: [
      { title: "All-black panel layout for ultra-premium look" , image: RRs2step1},
      { title: "Design-first mounting (hidden wiring, minimal conduit visibility)" , image: RRs2step2},
      { title: "Elevated structures / pergolas / carports (optional)" , image: RRs2step3},
      { title: "Inverter & battery placement for visual harmony" , image: RRs2step4},
      { title: "Cable routing with zero aesthetic disturbance" , image: RRs2step5},
      { title: "Simulation of generation vs home needs" , image: RRs2step6},
    ],
  },
  {
    id: 3,
    title: "Tech Selection",
    steps: [
      { title: "N-Type TOPCon or All-Black mono panels" , image: RRs3step1},
      { title: "Hybrid inverters for solar + grid + battery integration" , image: RRs3step2},
      { title: "Optional microinverter architecture for shaded rooftops" , image: RRs3step3},
      { title: "Lithium LiFePO4 home battery sizing (5–20 kWh)" , image: RRs3step4},
      { title: "Home automation integration options" , image: RRs3step5},
      { title: "EV charging compatibility planning" , image: RRs3step6},
      { title: "Selection of global Tier-1 components" , image: RRs3step7},
    ],
  },
  {
    id: 4,
    title: "Financial Planning",
    steps: [
      { title: "Final system costing (CAPEX)" , image: RRs4step1},
      { title: "Optional EMI/finance structure" , image: RRs4step2},
      { title: "Payback & lifetime savings modelling" , image: RRs4step3},
      { title: "Battery backup hour calculation" , image: RRs4step4},
      { title: "Load shifting & home energy efficiency modelling" , image: RRs4step5},
      { title: "Final techno-commercial proposal" , image: RRs4step6},
    ],
  },
  {
    id: 5,
    title: "Approvals & Prep",
    steps: [
      { title: "Net-metering or grid-interactive permission" , image: RRs5step1},
      { title: "Home electrical audit & load balancing plan" , image: RRs5step2},
      { title: "Transformer and service line compatibility check" , image: RRs5step3},
      { title: "Safety compliance documentation (earthing, SPD, wiring standards)" , image: RRs5step4},
      { title: "Approval timeline tracking inside TrueTrack™" , image: RRs5step5},
      { title: "Alerts to homeowner for any required documentation" , image: RRs5step6},
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "Final rooftop layout & SLD" , image: RRs6step1},
      { title: "Module, inverter, battery, structure procurement" , image: RRs6step2},
      { title: "Pre-dispatch quality checks" , image: RRs6step3},
      { title: "Logistics scheduling & material tracking" , image: RRs6step4},
      { title: "Waterproofing plan for all cable routes" , image: RRs6step5},
      { title: "Engineering checklist completion inside TrueTrack™" , image: RRs6step6},
    ],
  },
  {
    id: 7,
    title: "Installation Execution",
    steps: [
      { title: "Daily installation logs with photos/videos" , image: RRs7step1},
      { title: "Structure mounting (zero-damage, safety-first)" , image: RRs7step2},
      { title: "Panel fixing & wiring with hidden conduit routing" , image: RRs7step3},
      { title: "Hybrid inverter + battery installation & testing" , image: RRs7step4},
      { title: "AC/DC wiring, earthing, lightning protection" , image: RRs7step5},
      { title: "Automated milestone updates" , image: RRs7step6},
      { title: "Homeowner dashboard for live visibility" , image: RRs7step7},
      { title: "Clean, dust-free, disturbance-free execution experience" , image: RRs7step8},
    ],
  },
  {
    id: 8,
    title: "Testing & Handover",
    steps: [
      { title: "Inverter + battery (hybrid mode) testing" , image: RRs8step1},
      { title: "Load balancing: home grid + DG interactions" , image: RRs8step2},
      { title: "Net meter installation (if applicable)" , image: RRs8step3},
      { title: "Safety validation: earthing, SPD, overcurrent protection" , image: RRs8step4},
      { title: "Final walkthrough & homeowner orientation" , image: RRs8step5},
      { title: "Handover documents, warranties & manuals" , image: RRs8step6},
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "Live solar generation view" , image: RRs9step1},
      { title: "Home consumption vs solar usage chart" , image: RRs9step2},
      { title: "Battery charge/discharge cycles" , image: RRs9step3},
      { title: "Grid vs solar vs battery usage tracking" , image: RRs9step4},
      { title: "AI-driven alerts: fault, inverter issue, underperformance" , image: RRs9step5},
      {
        title: "Dual dashboards:",
        image: RRs9step6,
        bullets: [
          "Engineering dashboard + SCADA-level insights",
          "Homeowner dashboard + Simple, intuitive interface",
        ],
      },
      { title: "Smart energy tips to reduce bills" , image: RRs9step7},
    ],
  },
  {
    id: 10,
    title: "Maintenance & Health",
    steps: [
      { title: "Annual maintenance visit scheduling" , image: RRs10step1},
      { title: "Battery health check & degradation tracking" , image: RRs10step2},
      { title: "Panel cleaning reminders & best-practice guidelines" , image: RRs10step3},
      { title: "Inverter firmware updates" , image: RRs10step4},
      { title: "Wiring & protection device inspections" , image: RRs10step5},
      { title: "Monthly digital system health reports" , image: RRs10step6},
      { title: "Service tickets with SLA-bound closure" , image: RRs10step7},
    ],
  },
  {
    id: 11,
    title: "Billing & Insights",
    steps: [
      { title: "Monthly electricity bill comparison (before vs after solar)" , image: RRs11step1},
      { title: "Savings tracker based on solar generation & battery use" , image: RRs11step2},
      { title: "EMI tracker (if financed)" , image: RRs11step3},
      { title: "Energy consumption analytics" , image: RRs11step4},
      { title: "Performance reporting for insurance claims" , image: RRs11step5},
      { title: "Export/import reconciliation (if net metering exists)" , image: RRs11step6},
      { title: "Carbon impact summary" , image: RRs11step7},
    ],
  },
  {
    id: 12,
    title: "Lifecycle Optimization",
    steps: [
      { title: "Annual performance benchmarking" , image: RRs12step1},
      {
        title: "Upgrade suggestions:", image: RRs12step2,
        bullets: ["Battery capacity expansion", "Microinverters"],
      },
      { title: "Replacement cycle planning (inverter/battery)" , image: RRs12step3},
      { title: "Long-term cost vs savings reporting" , image: RRs12step4},
      { title: "Digital record archive: invoices, warranties, performance logs" , image: RRs12step5},
    ],
  },
];

const RR_N = rrStages.length;
const RR_RADIUS = 380;
const RR_ANGLE_STEP = 30;
const RR_MINOR_TICKS = 72;

const ResidentialRooftopHowItWorks = () => {
  const sectionRef = useRef(null);
  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);
  const activeStageRef = useRef(0);
  const logoRef = useRef(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".rr-hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;
      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * RR_N;
      const activeFloat = Math.min(arcFloat, RR_N - 1);
      const activeIndex = Math.round(activeFloat);
      const currentRotation = -(activeFloat * RR_ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }
      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      rrStages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;
        const dist = activeFloat - i;
        let opacity = 1;
        if (Math.abs(dist) < 0.5) opacity = 0;
        else if (dist > 0.5) opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        else if (dist < -5) opacity = 0;
        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;
        numEl.style.transform = `rotate(${-(i * RR_ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, RR_N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }
      raf = requestAnimationFrame(update);
    };

    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = rrStages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -cardsContainerRef.current.offsetWidth : cardsContainerRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="rr-hiw-outer"
      ref={sectionRef}
      style={{ height: `${rrStages.length * 110}vh` }}
    >
      <div className="rr-hiw-header-wrap">
        <div className="rr-hiw-tag">
          <span className="rr-hiw-dot"></span>
          HOW IT WORKS
        </div>
        <h2 className="rr-hiw-title">True 360° Execution Cycle</h2>
        <p className="rr-hiw-subtitle">
          A high-performance, design-first, intelligent solar experience powered
          by TrueTrack™, TrueCare™ &amp; TrueCom™.
        </p>
      </div>

      <div className="rr-hiw-sticky">
        <div className="rr-hiw-split">
          {/* LEFT: DIAL */}
          <div className="rr-hiw-left">
            <div className="rr-hiw-mobile-header">
              <div className="rr-hiw-tag">
                <span className="rr-hiw-dot"></span>
                HOW IT WORKS
              </div>
              <h2 className="rr-hiw-title">True 360° Execution Cycle</h2>
              <p className="rr-hiw-subtitle">
                A high-performance, design-first, intelligent solar experience
                powered by TrueTrack™, TrueCare™ &amp; TrueCom™.
              </p>
            </div>

            <div className="rr-hiw-dial-wrapper">
              <div className="rr-hiw-dial-container" ref={dialRef}>
                <div className="rr-hiw-dial-bg"></div>
                <div className="rr-hiw-dial-inner-orange"></div>

                {Array.from({ length: RR_MINOR_TICKS }).map((_, i) => (
                  <div
                    key={`rr-tick-${i}`}
                    className="rr-hiw-dial-tick-min"
                    style={{ transform: `rotate(${i * (360 / RR_MINOR_TICKS)}deg) translate(${RR_RADIUS}px)` }}
                  />
                ))}

                <svg
                  style={{
                    position: "absolute", top: "50%", left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "678px", height: "678px",
                    pointerEvents: "none", zIndex: 2,
                  }}
                >
                  <circle
                    ref={arcRef}
                    cx="339" cy="339" r="333"
                    fill="none" stroke="#F05A28" strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333}
                    strokeDashoffset={2 * Math.PI * 333}
                    strokeLinecap="round"
                  />
                </svg>

                {rrStages.map((stage, i) => {
                  const itemAngle = i * RR_ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;
                  return (
                    <React.Fragment key={stage.id}>
                      <div
                        className={`rr-hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${RR_RADIUS}px)` }}
                      />
                      <div
                        className={`rr-hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${RR_RADIUS + 40}px)` }}
                      >
                        <div
                          className="rr-hiw-dial-num"
                          ref={(el) => (numRefs.current[i] = el)}
                          style={{ transform: "rotate(-90deg)" }}
                        >
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="rr-hiw-dial-inner">
                <img src={trueRenewablesLogo} alt="True Renewables" className="rr-hiw-center-logo" ref={logoRef} loading="lazy" />
                <div className="rr-hiw-dial-pointer"></div>
              </div>

              <div className="rr-hiw-active-overlay">
                <div className="rr-hiw-inner-faint-line"></div>
                <div className="rr-hiw-active-thick-line"></div>
                <div className="rr-hiw-active-dot"></div>
                <div className="rr-hiw-active-text-block">
                  <span className="rr-hiw-active-num">{numStr}</span>
                  <span className="rr-hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="rr-hiw-mobile-info">
              <div className="rr-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="rr-hiw-mobile-title">{currentStage.title}</h3>
              <p className="rr-hiw-mobile-desc">
                {currentStage.steps.map((s) => s.title).join(", ")}
              </p>
              <button className="rr-hiw-mobile-view-btn" onClick={() => setIsMobilePopupOpen(true)}>
                VIEW DETAILS ↗
              </button>
            </div>
          </div>

          {/* RIGHT: CONTENT */}
          <div className={`rr-hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div className="rr-hiw-popup-bg" onClick={() => setIsMobilePopupOpen(false)}></div>
            <div className="rr-hiw-popup-inner">
              <button className="rr-hiw-popup-close" onClick={() => setIsMobilePopupOpen(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="rr-hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="rr-hiw-right-title">{currentStage.title}</h2>

              <div className="rr-hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="rr-hiw-step-card">
                    <div className="rr-hiw-step-img-wrap">
                      <img src={step.image} alt={step.title} className="rr-hiw-step-img" loading="lazy" />
                    </div>
                    <div className="rr-hiw-step-text">
                      <p className="rr-hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="rr-hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="rr-hiw-step-bullets">
                          {step.bullets.map((bullet, i) => (
                            <li key={i} className="rr-hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="rr-hiw-nav-arrows">
                <button type="button" className="rr-hiw-nav-arrow" onClick={() => scrollCards("left")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button type="button" className="rr-hiw-nav-arrow" onClick={() => scrollCards("right")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>

              <div className="rr-hiw-popup-mobile-info">
                <div className="rr-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="rr-hiw-mobile-title">{currentStage.title}</h3>
                <p className="rr-hiw-mobile-desc">
                  {currentStage.steps.map((s) => s.title).join(", ")}
                </p>
                <button className="rr-hiw-mobile-view-btn popup-btn" onClick={() => setIsMobilePopupOpen(false)}>
                  VIEW DETAILS ↗
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   SECTION 7 — WHY CHOOSE US
   ================================================ */
const ResidentialRooftopWhyChooseUs = () => {
  const leftCards = [
    { num: "01", text: "Premium engineering for villas & modern homes." },
    {
      num: "02",
      text: "Tier-1 global components only and Smart home compatibility (IoT-enabled).",
    },
    {
      num: "03",
      text: "Aesthetic-first designs (black panels, hidden conduits, elevated structures).",
    },
  ];
  const rightCards = [
    { num: "04", text: "Real-time transparency with TrueTrack™." },
    { num: "05", text: "24/7 performance monitoring with TrueCare™." },
    { num: "06", text: "Complete commercial clarity via TrueCom™." },
  ];

  return (
    <section className="rr-why">
      <div className="rr-why-header">
        <p className="rr-why-tag">
          <span className="rr-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="rr-why-title">Smart Solar For Modern Homes</h2>
      </div>

      <div className="rr-why-body">
        <div className="rr-why-col">
          {leftCards.map((c) => (
            <div className="rr-why-card" key={c.num}>
              <p className="rr-why-num">{c.num}</p>
              <p className="rr-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="rr-why-img-wrap">
          <img src={rrWhyImg} alt="Why Choose Us" className="rr-why-img" loading="lazy" />
        </div>

        <div className="rr-why-col">
          {rightCards.map((c) => (
            <div className="rr-why-card" key={c.num}>
              <p className="rr-why-num">{c.num}</p>
              <p className="rr-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 8 — FEATURED PROJECTS
   ================================================ */
const ResidentialRooftopFeaturedProjects = () => {
  const projects = [
    {
      img: rrProj1,
      title: "Premium Villa Rooftop Solar – Ahmedabad",
      desc: "Designed for a luxury villa community, this rooftop installation offsets up to 80% of annual household consumption.",
      tags: ["AHMEDABAD", "12 kW", "VILLA COMMUNITY"],
    },
    {
      img: rrProj2,
      title: "Smart Hybrid Solar Home – Pune",
      desc: "Seeking uninterrupted power during grid outages, this hybrid system ensures seamless backup for essential appliances.",
      tags: ["PUNE", "HYBRID SYSTEM", "8 kW"],
    },
  ];

  return (
    <section className="rr-projects">
      <div className="rr-projects-header">
        <p className="rr-projects-tag">
          <span className="rr-projects-dot" />
          FEATURED PROJECTS
        </p>
        <h2 className="rr-projects-title">
          Energy-Independent Homes In Action
        </h2>
      </div>

      <div className="rr-projects-grid">
        {projects.map((p, i) => (
          <div className="rr-projects-card" key={i}>
            <div className="rr-projects-img-wrap">
              <img src={p.img} alt={p.title} className="rr-projects-card-img" loading="lazy" />
            </div>
            <div className="rr-projects-card-body">
              <h3 className="rr-projects-card-title">{p.title}</h3>
              <p className="rr-projects-card-desc">{p.desc}</p>
              <div className="rr-projects-tags">
                {p.tags.map((tag, j) => (
                  <span className="rr-projects-tag-pill" key={j}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
// /* ================================================
//    SECTION 9 — TESTIMONIALS
//    ================================================ */
// const ResidentialRooftopTestimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Anjali Verma",
//       role: "Property Owner, Bengaluru",
//       quote: '"True Renewables made our solar installation simple and hassle-free. The team was professional throughout the process."',
//       photo: Testi1,
//     },
//     {
//       id: 2,
//       name: "Sandeep Reddy",
//       role: "Managing Director, Reddy Commercial Spaces",
//       quote: '"The installation was smooth and the system is performing very well. A reliable team to work with."',
//       photo: Testi2,
//     },
//     {
//       id: 3,
//       name: "Harshvardhan Kulkarni",
//       role: "Director, Altura Industrial Solutions",
//       quote: '"True Renewables delivered a dependable solar solution for our facility and helped reduce our energy costs."',
//       photo: Testi3,
//     },
//   ];

//   const ChevronLeft = () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
//       stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="15 18 9 12 15 6" />
//     </svg>
//   );

//   const ChevronRight = () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
//       stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="9 18 15 12 9 6" />
//     </svg>
//   );

//   const [current, setCurrent] = useState(0);
//   const [slideDir, setSlideDir] = useState("");
//   const [animKey, setAnimKey] = useState(0);
//   const total = testimonials.length;

//   const prev = () => { setSlideDir("rr-testi-slide-left");  setAnimKey((k) => k + 1); setCurrent((c) => (c - 1 + total) % total); };
//   const next = () => { setSlideDir("rr-testi-slide-right"); setAnimKey((k) => k + 1); setCurrent((c) => (c + 1) % total); };

//   const TestimonialCard = ({ item, animClass }) => (
//     <div className={`rr-testi-card ${animClass || ""}`}>
//       <div className="rr-testi-card-content">
//         <div className="rr-testi-person">
//           <div>
//             <p className="rr-testi-name">{item.name}</p>
//             <p className="rr-testi-role">{item.role}</p>
//           </div>
//         </div>
//         <hr className="rr-testi-divider" />
//         <p className="rr-testi-quote">{item.quote}</p>
//       </div>
//       <div className="rr-testi-card-photo">
//         {item.photo
//           ? <img src={item.photo} alt={item.name} className="rr-testi-photo" />
//           : <div className="rr-testi-photo-placeholder" />}
//       </div>
//     </div>
//   );

//   return (
//     <section className="rr-testi-section">
//       <div className="rr-testi-header">
//         <div className="rr-testi-header-left">
//           <p className="rr-testi-tag"><span className="rr-testi-dot"></span> TESTIMONIALS</p>
//           <h2 className="rr-testi-title">Trusted By Clients Across<br />Industries</h2>
//         </div>
//         <div className="rr-testi-header-right">
//           <p className="rr-testi-subtitle">
//             Real experiences from clients who trust us<br />with their solar journey.
//           </p>
//           <div className="rr-testi-arrows">
//             <button className="rr-testi-arrow" onClick={prev} aria-label="Previous"><ChevronLeft /></button>
//             <button className="rr-testi-arrow" onClick={next} aria-label="Next"><ChevronRight /></button>
//           </div>
//         </div>
//       </div>

//       <div className="rr-testi-cards" key={animKey}>
//         <TestimonialCard item={testimonials[current % total]}       animClass={slideDir} />
//         <TestimonialCard item={testimonials[(current + 1) % total]} animClass={`${slideDir} rr-testi-delay`} />
//       </div>
//     </section>
//   );
// };

/* ================================================
   RESIDENTIAL ROOFTOP PAGE
   ================================================ */

function ResidentialRooftop() {
  useEffect(() => {
    document.body.classList.add("residential-page");

    return () => {
      document.body.classList.remove("residential-page");
    };
  }, []);

  return (
    <div>
      <ResidentialRooftopHero />
      <ResidentialRooftopBenefits />
      <ResidentialRooftopPanels />
      <ResidentialRooftopBattery />
      <ResidentialRooftopArchitecture />
      <ResidentialRooftopHowItWorks />
      <ResidentialRooftopWhyChooseUs />
      <ResidentialRooftopFeaturedProjects />
    </div>
  );
}

export default ResidentialRooftop;
